import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=70cb9b9e&scoped=true&"
import script from "./FileView.vue?vue&type=script&lang=js&"
export * from "./FileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb9b9e",
  null
  
)

export default component.exports